import { TooltipButton } from './tooltip-button';

export default TooltipButton;
